import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconNames } from '@dotcom/crown-ui';
import classNames from 'classnames';
import { CollapseSectionProps } from '../../address-form/address-form-types';
import styles from '../../address-form/address-form.module.scss';
import { IconButton } from '../../icon-button/icon-button';
import { CollapsePanel } from './collapse-panel/collapse-panel';
import { CollapsePanelVariants } from './collapse-panel/collapse-panel-types';

export const CollapseSection = ({ children }: CollapseSectionProps): React.ReactElement => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { t } = useTranslation();
  const CollapseTrigger = (): React.ReactElement => (
    // <Button
    //   variant="link"
    //   className={classNames(styles['collapse-trigger'], styles['text-link'])}
    //   onClick={() => {
    //     setIsCollapsed(!isCollapsed);
    //   }}
    //   testId={'collapse-button'}
    // >
    //   Address line 2 and company name
    //   <Icon
    //     name={isCollapsed ? IconNames.ExpandBold : IconNames.RemoveBold}
    //     className={classNames(styles['collapse-icon'], {
    //       [styles['collapsed']]: isCollapsed,
    //     })}
    //   />
    // </Button>
    <IconButton
      onClick={() => {
        setIsCollapsed(!isCollapsed);
      }}
      variant="link"
      className={classNames(styles['collapse-trigger'], styles['text-link'])}
      testId={'collapse-button'}
      label={t('addressForm.optionalAddressFields')}
      iconPosition="right"
      iconSize="14"
      iconName={isCollapsed ? IconNames.ExpandBold : IconNames.RemoveBold}
      iconClassName={classNames(styles['collapse-icon'], {
        [styles['collapsed']]: isCollapsed,
      })}
    />
  );
  return (
    <CollapsePanel
      isOpen={!isCollapsed}
      trigger={<CollapseTrigger />}
      addClass={styles['collapse-panel']}
      variant={CollapsePanelVariants.Default}
    >
      {!isCollapsed && children}
    </CollapsePanel>
  );
};
